module.exports = __webpack_public_path__ + "img/img-4.99433093.jpg";